import { createTheme } from '@material-ui/core/styles'
import theme from './theme'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as ThemeAugmentation from '@material-ui/lab/themeAugmentation'

const materialTheme = createTheme({
  palette: {
    primary: {
      main: theme.colors.primary
    },
    secondary: {
      main: theme.colors.secondary
    }
  },
  overrides: {
    MuiAlert: {
      root: {
        borderRadius: '8px',
        padding: '4px 16px',
        lineHeight: '24px',
        minWidth: '550px'
      },
      message: {
        fontWeight: 600,
        fontSize: '14px',
        letterSpacicng: '0.1px'
      },
      filledInfo: {
        backgroundColor: theme.colors.white,
        color: theme.colors.black
      },
      filledSuccess: {
        backgroundColor: theme.colors.primary
      }
    },
    MuiSvgIcon: {
      root: {
        width: '24px',
        height: '24px'
      }
    },
    MuiButton: {
      root: {
        borderRadius: '8px',
        fontFamily: 'IBMPlexSans-Bold',
        fontSize: '16px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'none'
        }
      },
      contained: {
        color: theme.colors.primary,
        backgroundColor: theme.colors.white,
        '&:disabled': {
          color: theme.colors.lightGray,
          backgroundColor: theme.colors.gray4
        }
      },
      outlined: {
        border: '2px solid #F0F2F1',
        color: '#F0F2F1'
      },
      outlinedSecondary: {
        color: '#079D56',
        border: '1px solid #079D56',
        fontSize: '12px'
      }
    },
    MuiCheckbox: {
      root: {
        padding: '4px'
      },
      colorSecondary: {
        color: theme.colors.secondary,

        '& + .MuiFormControlLabel-label': {
          color: theme.colors.primary
        },
        '&.Mui-checked': {
          '& + .MuiFormControlLabel-label': {
            fontWeight: theme.font.bold
          }
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: '0'
      },
      edgeEnd: {
        marginRight: '0'
      },
      colorPrimary: {
        color: theme.colors.gray4
      }
    },
    MuiAccordionSummary: {
      root: {
        padding: '0 32px'
      },
      content: {
        fontFamily: 'IBMPlexSans-Bold',
        fontSize: theme.font.sizes.xlarge,
        '&.Mui-expanded': {
          margin: '40px 0'
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        fontFamily: theme.font.family,
        fontSize: '14px'
      }
    },
    MuiOutlinedInput: {
      input: {
        fontSize: '14px',
        fontFamily: theme.font.family
      },
      root: {
        '&$disabled': {
          backgroundColor: theme.colors.gray2,
          color: 'rgba(0, 0, 0, 0.87)',
          '& fieldset': {
            border: 'none'
          }
        }
      }
    },
    MuiTextField: {
      root: {
        width: '100%'
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: theme.font.family,
        color: theme.colors.primary,
        fontSize: '14px',
        lineHeight: '1.43'
      },
      colorSecondary: {
        color: theme.colors.black
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: '12px'
      },
      contained: {
        marginRight: '0',
        marginLeft: '0',
        margin: '4px 0 0 0'
      }
    },
    MuiAccordion: {
      rounded: {
        borderRadius: '8px'
      },
      root: {
        margin: '24px 0',
        '&$expanded': {
          margin: '32px 0'
        },
        '&:before': {
          display: 'none'
        }
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow: '0px 2px 6px rgb(0 0 0 / 15%)'
      },
      rounded: {
        borderRadius: '8px'
      }
    },
    MuiAccordionDetails: {
      root: {
        padding: '8px 32px 32px'
      }
    },
    MuiSelect: {
      select: {
        display: 'grid',
        alignItems: 'center'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '14px'
      }
    },
    MuiTableCell: {
      root: {
        fontFamily: theme.font.family
      },
      head: {
        fontWeight: theme.font.bold,
        fontSize: theme.font.sizes.xsmall,
        color: theme.colors.primary,
        backgroundColor: theme.colors.lightGreen
      },
      body: {
        color: theme.colors.black,
        fontSize: theme.font.sizes.small
      }
    },
    MuiCardActions: {
      root: {
        padding: '16px',
        justifyContent: 'end'
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: theme.colors.gray3,
        fontSize: theme.font.sizes.xsmall,
        fontWeight: theme.font.bold,
        padding: '10px'
      },
      arrow: {
        color: theme.colors.gray3
      }
    },
    MuiTabs: {
      root: {
        borderBottom: `1px solid ${theme.colors.lightGray}`
      },
      indicator: {
        height: 4,
        transform: 'translateY(-44px)',
        backgroundColor: theme.colors.primary
      }
    },
    MuiTab: {
      root: {
        fontFamily: theme.font.family,
        fontSize: theme.font.sizes.medium,
        fontWeight: theme.font.bold,
        color: theme.colors.gray4,
        '&.Mui-selected': {
          color: theme.colors.primary,
          backgroundColor: theme.colors.lightGreen
        },
        '&:hover': {
          backgroundColor: theme.colors.gray2,
          opacity: 1
        }
      }
    }
  }
})

export default materialTheme
